/**
 * Project Name : cop-web-portal
 * File Name : columnFix.js
 * Description : 컬럼 고정 Custom Directive
 * Author : dhoop.lee
 * Date : 2023.7.12
 */
const columnFix = (el, binding) => {
  const { nodeName } = el;
  // 테이블에 붙은 경우에만 실행된다.
  if (['TABLE'].indexOf(nodeName) < 0) return;
  const { expression } = binding;
  // binding 된 파라미터에서 숫자와 , 만 남기고 배열로 변환
  const columnIdxs = expression
    .replace(/[^0-9\,]/g, '')
    .split(',')
    .map(exp => Number(exp));
  if (columnIdxs.length === 0) return;
  // 전체 컬럼 헤더를 조회한다.
  const ths = el.querySelector('thead').querySelectorAll('th');
  // 전체 행을 조회한다.
  const trs = el.querySelector('tbody').querySelectorAll('tr');
  let widthSum = 0;
  columnIdxs.forEach(columnIdx => {
    // 파라미터에 해당하는 컬럼 헤더에 style과 custom attribute(식별용)를 준다.
    ths[columnIdx].dataset.fix = 'sticky_column';
    ths[columnIdx].style.position = 'sticky';
    ths[columnIdx].style.zIndex = '2';
    ths[columnIdx].style.left = `${widthSum}px`;
    trs.forEach(tr => {
      // 파라미터에 해당하는 cell에 style과 custom attribute(식별용)를 준다.
      const tds = tr.querySelectorAll('td');
      if (tds[columnIdx]) {
        tds[columnIdx].dataset.fix = 'sticky_column';
        tds[columnIdx].style.left = `${widthSum}px`;
        tds[columnIdx].style.position = 'sticky';
        tds[columnIdx].style.zIndex = '1';
      }
    });
    // 해당 컬럼 고정의 위치는 각 헤더의 실제 width의 합으로 결정된다.
    widthSum += Number(ths[columnIdx].offsetWidth);
  });
};
export default {
  inserted(el, binding) {
    columnFix(el, binding);
  },
  componentUpdated(el, binding) {
    columnFix(el, binding);
  },
};



// WEBPACK FOOTER //
// ./src/directives/columnFix.js